import { render } from "./PlayerDashboard.vue?vue&type=template&id=666b0937&scoped=true"
import script from "./PlayerDashboard.vue?vue&type=script&lang=js"
export * from "./PlayerDashboard.vue?vue&type=script&lang=js"

import "@/routes/match_officials/officialDashboard.css?vue&type=style&index=0&id=666b0937&scoped=true&lang=css&external"
import "./PlayerDashboard.vue?vue&type=style&index=1&id=666b0937&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666b0937"]])

export default __exports__